const carousel = {
  product: {
    variations: 'Customers also bought',
    recommendations: 'Recommended products',
    offer: 'Our offers',
    offerLink: 'To the product overview',
    indicator: 'Products of the month',
  },
  card: {
    prescriptionMsg: 'Laden Sie ein (E-)Rezept hoch, um dieses Produkt zu reservieren.',
    pricesMayVary: 'Preise variieren je nach Apotheke.',
    toProduct: 'Zum Produkt',
    toCart: 'In den Warenkorb',
    uploadPrescription: '(E-)Rezept hochladen',
  },
}

export default carousel
